<div class="ui basic segment" [class.loading]="isLoading">
    <app-header [title]="'training.createNewProgram'" [back]="true"></app-header>
    <div class="ui layout">
        <div class="content">
            <div class="ui segment">
                <app-form-training-program #trainingProgramForm [program]="program"> </app-form-training-program>
            </div>
            <div style="display: flex; justify-content: flex-end">
                <ui-button type="ghost" (click)="onCancel()">{{ 'cancel' | translate }}</ui-button>
                <ui-button type="primary" (click)="onSave(trainingProgramForm)">{{ 'save' | translate }}</ui-button>
            </div>
        </div>

        <div class="sidebar">
            <div class="ui segment">
                <h3>{{ 'training.trainingPrograms' | translate }}</h3>
                <p>{{ 'training.programmWillBeAssigned' | translate }}</p>
                <p [innerHTML]="'training.learnMoreWithLink' | translate"></p>
            </div>
        </div>
    </div>
</div>
